//@flow
import ApiClient from 'utils/ApiClient';
import Dispatcher from 'dispatcher';
import { SET_TENANT_REPORT } from 'modules/external_tenant/api/action_types/TenantReportActionTypes';

class TenantReportActions {
  fetchTenantReport = (
    userId: string,
    applicationId: string,
    token: string
  ) => {
    return ApiClient.get({
      path: `/users/${userId}/home_applications/${applicationId}/preview_report?token=${token}`,
      skipRedirect: true
    }).then(response => {
      Dispatcher.dispatch({
        type: SET_TENANT_REPORT,
        payload: response.report
      });
    });
  };

  sendWhatsapp = (applicationId: string, data?: any) => {
    return ApiClient.get({
      data: data,
      path: `/home_applications/${applicationId}/external_owners_info/owner_whatsapp_notification`
    });
  };
}

export default new TenantReportActions();
